import { useState } from 'react'
import { getCVUInfo } from '../services/accountService'
import { LuWallet, LuSearch, LuUser, LuIdCard, LuBarcode } from 'react-icons/lu'
import './CVUInfoPage.css'

function CVUInfoPage() {
  const [cvu, setCvu] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [cvuData, setCvuData] = useState(null)

  const handleConsultar = async (e) => {
    e.preventDefault()
    
    if (!cvu.trim()) {
      setError('Debe ingresar un CVU o alias')
      return
    }

    setLoading(true)
    setError('')
    setCvuData(null)

    try {
      const response = await getCVUInfo(cvu.trim())
      setCvuData(response)
    } catch (err) {
      const errorMsg = err.response?.data?.error || 'Error al consultar información'
      const httpCode = err.response?.data?.httpCode || err.response?.status || 500
      setError(`HTTP ${httpCode} - ${errorMsg}`)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1><LuWallet /> Información de Cuenta</h1>
      </div>

      <div className="cvu-info-container">
        <div className="cvu-info-card">
          <h2>Buscar por CVU o Alias</h2>
          <form onSubmit={handleConsultar} className="cvu-form">
            <div className="cvu-search-row">
              <input
                type="text"
                value={cvu}
                onChange={(e) => setCvu(e.target.value)}
                placeholder="Ingrese CVU, CBU o alias para consultar"
                className="form-control cvu-search-input"
                disabled={loading}
              />
              <button 
                type="submit" 
                className="btn-primary cvu-search-btn"
                disabled={loading || !cvu.trim()}
              >
                {loading ? (
                  <>
                    <div className="spinner-small"></div>
                    Buscando...
                  </>
                ) : (
                  <>
                    <LuSearch /> Consultar
                  </>
                )}
              </button>
            </div>
          </form>

          {error && <div className="error-message">{error}</div>}

          {cvuData && cvuData.fullResponse && (
            <div className="cvu-result">
              <h3>Datos de la Cuenta</h3>
              <div className="cvu-info-grid">
                <div className="info-card">
                  <div className="info-icon">
                    <LuUser />
                  </div>
                  <div className="info-content">
                    <span className="info-label">Nombre</span>
                    <span className="info-value">{cvuData.fullResponse.nombre || '-'}</span>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">
                    <LuIdCard />
                  </div>
                  <div className="info-content">
                    <span className="info-label">CUIT</span>
                    <span className="info-value">{cvuData.fullResponse.cuit || '-'}</span>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">
                    <LuBarcode />
                  </div>
                  <div className="info-content">
                    <span className="info-label">CVU</span>
                    <span className="info-value mono">{cvuData.fullResponse.cvu || '-'}</span>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">
                    <LuWallet />
                  </div>
                  <div className="info-content">
                    <span className="info-label">Alias</span>
                    <span className="info-value">{cvuData.fullResponse.alias || '-'}</span>
                  </div>
                </div>

                <div className="info-card full-width">
                  <div className="info-content">
                    <span className="info-label">Tipo de Persona</span>
                    <span className="info-value">
                      {cvuData.fullResponse.tipo_persona === 'F' ? 'Persona Física' : 
                       cvuData.fullResponse.tipo_persona === 'J' ? 'Persona Jurídica' : 
                       cvuData.fullResponse.tipo_persona || '-'}
                    </span>
                  </div>
                </div>
              </div>
              
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default CVUInfoPage

